import React from 'react'
import './animation.css'
const Animation = () => {
     return <></>
}

export default Animation
